import { apiWrapper } from "@/services/api";
import store from "@/store";

export const getDemandBusStops = async () => {
  try {
    const response = await apiWrapper(
      "GET",
      `/busstops?serviceAreaIds[]=1082`,
      null,
      false,
      false,
      "E-BUS"
    );
    let returnArray = [];
    response.data.busstops.forEach((elm) => {
      returnArray.push({ id: elm.id, name: elm.name });
    });
    return returnArray;
  } catch (err) {
    console.log('ERROR"" getDemandBusStops():', err);
    throw err;
  }
};
